import React from 'react';
import PropTypes from 'prop-types';
import { timeFromNow } from '../../utils/date';

export default function OwnerAndTime({
  owner,
  avatar,
  createdAt,
  wrapperClass,
}) {
  return (
    <div className={`flex gap-x-3 items-center text-sm ${wrapperClass}`}>
      <img
        src={avatar}
        alt={owner}
        height="25"
        width="25"
        className="rounded-full"
      />
      <div className="flex flex-col md:flex-row gap-x-9 md:items-center">
        <div className="font-semibold">{owner}</div>
        <div className="text-sm font-medium text-zinc-500 dark:text-zinc-400">
          {timeFromNow(createdAt)}
        </div>
      </div>
    </div>
  );
}

OwnerAndTime.propTypes = {
  owner: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
};

OwnerAndTime.defaultProps = {
  wrapperClass: '',
};
